module.exports = __webpack_public_path__ + "img/wgsewm.ddd8fc9b.png";